
const URL = process.env.API_URL;
const TOKEN =  process.env.TOKEN;

export const sendForm = async (formData) => {
    const body = {
        type: "News",
        email: formData.email
    };

    try {
        const response = await fetch(`${URL}/form`, {
            method: "POST",
            body: JSON.stringify(body),
            headers: {
                'Content-Type': 'application/json',
                Authorization: TOKEN
            }
        });

        if (response.status !== 200) {
            throw new Error("Что-то пошло не так")
        }


    } catch (e) {
        return e;
    }

    return false;
}